import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MyactivePage } from './myactive';

@NgModule({
  declarations: [
    MyactivePage,
  ],
  imports: [
    IonicPageModule.forChild(MyactivePage),
  ],
})
export class MyactivePageModule {}



// WEBPACK FOOTER //
// ./src/pages/myactive/myactive.module.ts